<template lang="pug">
  div(class="input-container" :class="cssClass")
      span(class="label" v-if="!isTypeSelect") {{field.name}}
      input(
        v-if="!isTypeSelect"
        v-model="fieldValue"
        :type="field.type"
        @input="onInput"
      )
      v-select(
        v-if='isTypeSelect'
        v-model='fieldValue'
        :label='field.name'
        :items='field.options'
        :prepend-icon="field.icon"
        @input="onInput"
      )
      slot(name="action")
</template>

<script>
export default {
  name: 'FieldValueV2',
  data() {
    return {
      fieldValue: this.field.value
    }
  },
  props: {
    action: {
      type: String,
      default: '',
    },
    field: {
      type: Object,
      default: {},
    },
    bottomLine: {
      type: Boolean,
      default: true
    },
    isContactOwner: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    field() {
      this.fieldValue = this.field.value;
    }
  },
  computed: {
    inputAttributes() {
      return {
        ...this.field.options && {options: this.field.options}
      };
    },
    isTypeSelect() {
      return this.field.type === "select";
    },
    hasAction() {
      return this.$slots.action;
    },
    cssClass() {
      return `${this.bottomLine && !this.isTypeSelect ? 'border-bottom' : ''} ${this.hasAction ? 'input-action' : ''} ${this.isTypeSelect ? 'input-select' : ''}`;
    }
  },
  methods: {
    onInput() {
      // Return without emitting if this is the first load or content is the same
      if (this.field.value === this.fieldValue) {
        return;
      }
      this.$emit('change', this.fieldValue);
    },
  }
};
</script>

<style lang="scss" scoped>
input, select {
  border: none;
  width: auto;
  font-weight: 450;
  font-size: 14px;
  outline: none;
  flex: 1;
}

.input-container {
  width: 95%;
  display: flex;
  align-items: baseline;
  margin: 2px;
}

.input-action {
  width: 100%;
}

.input-select {
  margin: 0 10px;
}

.border-bottom {
  border-bottom: 0.5px solid #d8d8d8;
}

.label {
  font-weight: 400;
  margin-right: 5px;
  font-size: 12px;
  color: #757575;
  flex: 0 0 auto;
}
</style>
